import { Edge, Node } from 'reactflow'

// Given a node being dragged, is there a child from this node? This is when we are being dropped between two nodes.
export const getDraggedChildNode = (node: Node, nodes: Node[], edges: Edge[]): Node | null => {
  if (!node) return null

  const downEdge = edges.find((e: Edge) => e.source === node.id && e.type === 'drag')

  if (!downEdge) return null

  const child = nodes.find((n) => n.id === downEdge.target)

  // so we can return null instead of returning undefined
  if (!child) return null
  else return child
}
